<template>
  <div class="navbar">
    <!-- 左侧Logo -->
    <div class="logo-container">
      <img src="/img/logo.png" alt="Logo" class="logo-image" />
    </div>
    
    <!-- 左侧导航 -->
    <div class="left-menu">
      <breadcrumb />
    </div>
    
    <!-- 右侧用户信息 -->
    <div class="right-menu">
      <!-- 通知图标 -->
      <!-- <div class="notification-icon">
        <el-icon><Bell /></el-icon>
        <span class="badge">5</span>
      </div> -->
      
      <!-- 用户信息 -->
      <el-dropdown trigger="click">
        <div class="avatar-wrapper">
          <img :src="(avatar && avatar != '') ? convertNetLinkHead(avatar) : '/img/avatar.png'" class="user-avatar" />
          <span class="username">{{ userInfo.username }}</span>
          <el-icon class="el-icon-arrow-down"><ArrowDown /></el-icon>
        </div>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item @click="$router.push('/profile/index')">个人中心</el-dropdown-item>
            <!-- <el-dropdown-item>账号设置</el-dropdown-item> -->
            <el-dropdown-item divided @click="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import Breadcrumb from './Breadcrumb.vue'
import { Bell, ArrowDown } from '@element-plus/icons-vue'
import { STORAGE_KEYS, storage, RESPONSE_CODE, convertNetLinkHead } from '@/utils/config'
import { ElMessage, ElLoading } from 'element-plus';

import req from '@/utils/req'
import { onMounted, onUnmounted, ref } from 'vue';
import emitter from '@/utils/eventBus'

const router = useRouter()
const userInfo = storage.get(STORAGE_KEYS.USER_INFO)
const avatar = ref(userInfo.avatar)
const logout = () => {
  req.request({
    url: '/login/logout',
    method: 'post',
  }).then(res=>{
    if (res.code == RESPONSE_CODE.SUCCESS) {
      storage.remove(STORAGE_KEYS.USER_INFO)
      storage.remove(STORAGE_KEYS.TOKEN)
      router.push('/login')
    }
  }).catch(err=>{
    ElMessage({
      message: err.message || '退出登录失败',
      type: 'error',
    });
  })
}
onMounted(()=>{
  emitter.on('updateUserInfo', ()=>{
    userInfo.value = storage.get(STORAGE_KEYS.USER_INFO)
    avatar.value = userInfo.value.avatar
  })
})
onUnmounted(()=>{
  emitter.off('updateUserInfo')
})
</script>

<style lang="scss" scoped>
.navbar {
  height: 60px;
  width:100%;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  .logo-container {
    display: flex;
    align-items: center;
    padding-left: 20px;
    
    .logo-image {
      height: 32px;
      margin-right: 15px;
    }
  }
  
  .left-menu {
    display: flex;
    align-items: center;
    flex: 1;
  }
  
  .right-menu {
    display: flex;
    align-items: center;
    padding-right: 20px;
    margin-left: auto;
    
    .notification-icon {
      position: relative;
      margin-right: 20px;
      font-size: 20px;
      cursor: pointer;
      
      .badge {
        position: absolute;
        top: -8px;
        right: -8px;
        display: inline-block;
        min-width: 16px;
        height: 16px;
        line-height: 16px;
        padding: 0 4px;
        border-radius: 8px;
        background-color: #f56c6c;
        color: #fff;
        text-align: center;
        font-size: 12px;
      }
    }
    
    .avatar-wrapper {
      display: flex;
      align-items: center;
      cursor: pointer;
      
      .user-avatar {
        width: 32px;
        height: 32px;
        border-radius: 50%;
      }
      
      .username {
        margin: 0 8px;
      }
    }
  }
}
</style> 